import { render, staticRenderFns } from "./OportunidadeDetalhe.vue?vue&type=template&id=250aa920&scoped=true"
import script from "./OportunidadeDetalhe.vue?vue&type=script&lang=js"
export * from "./OportunidadeDetalhe.vue?vue&type=script&lang=js"
import style0 from "./OportunidadeDetalhe.vue?vue&type=style&index=0&id=250aa920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250aa920",
  null
  
)

export default component.exports